import React, { useState } from "react";
import { RsvpMode, TicketTier } from "../types";

interface Props {
  weddingId: string;
  rsvpMode?: RsvpMode;
  onMatch: (
    guestId: string,
    rsvpId: string,
    ticketTier: TicketTier,
    plusOneLimit: number,
    status: string,
    extras?: { is_plus_one?: boolean; manage_rsvp_id?: string | null }
  ) => void;
}

const RsvpForm: React.FC<Props> = ({ weddingId, rsvpMode = "restricted", onMatch }) => {
  const [form, setForm] = useState({
    full_name: "",
    email: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const { matchRsvp } = await import("../api/rsvp");
      const { data } = await matchRsvp({
        wedding_id: weddingId,
        full_name: form.full_name,
        email: form.email || undefined,
      });
      onMatch(
        data.guest_id,
        data.rsvp_id,
        data.ticket_tier,
        data.plus_one_limit,
        data.status,
        {
          is_plus_one: data.is_plus_one,
          manage_rsvp_id: data.manage_rsvp_id,
        }
      );
    } catch (err) {
      setError(err instanceof Error ? err.message : "Match failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="form" onSubmit={handleSubmit}>
      <h3>Find Your Invitation</h3>
      <p className="form-hint">
        Enter your name as it appears on the invitation. Email helps when names are similar.
        Plus-ones who were added by a guest can match here too.
      </p>

      {error && <div className="error-message inline">{error}</div>}

      <div className="form-group">
        <label htmlFor="full_name">Full Name *</label>
        <input
          id="full_name"
          name="full_name"
          value={form.full_name}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="email">
          Email {rsvpMode === "restricted" ? "(recommended)" : "(optional)"}
        </label>
        <input
          id="email"
          name="email"
          type="email"
          value={form.email}
          onChange={handleChange}
        />
      </div>

      <button type="submit" className="btn btn-primary" disabled={loading}>
        {loading ? "Searching..." : "Find My Invitation"}
      </button>
    </form>
  );
};

export default RsvpForm;
